<ngx-file-drop
    dropZoneLabel="Arraste arquivos aqui"
    (onFileDrop)="getRowsFromFile($event)"
    accept=".xlsx, .xlsm"
    class="dropzone"
>
    <ng-template
        ngx-file-drop-content-tmp
        let-openFileSelector="openFileSelector"
    >
        <div class="dropzone__upload" (click)="openFileSelector()">
            <p class="dropzone__upload__text">
                Arraste os arquivos para cá
                <br />
                ou
                <br />
                <span>clique para procurar</span>
            </p>
        </div>
    </ng-template>
</ngx-file-drop>
<div class="files-name" *ngIf="fileName">
    <div class="file" *ngFor="let name of fileName">
        <mb-icon [svgColor]="'#49AE72'" [size]="'sm'" [icon]="'xlsx'"></mb-icon>
        <span>{{ name }}</span>
        <mb-icon
            [svgColor]="'#E45275'"
            [size]="'sm'"
            [icon]="'close'"
            (click)="removeFiles()"
        ></mb-icon>
    </div>
</div>
